module.exports = __webpack_public_path__ + "img/file-download-line.533f7a81.svg";